import { render, staticRenderFns } from "./goodsCodeList.vue?vue&type=template&id=deae5952&scoped=true&"
import script from "./goodsCodeList.vue?vue&type=script&lang=js&"
export * from "./goodsCodeList.vue?vue&type=script&lang=js&"
import style0 from "./goodsCodeList.vue?vue&type=style&index=0&id=deae5952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae5952",
  null
  
)

export default component.exports